module.exports = __webpack_public_path__ + "img/29.b5950724.png";